import { all } from 'redux-saga/effects';
import TIMSaga from './tim-saga';
import NIMSaga from './nim-saga';

export default function* root() {
  yield all([...NIMSaga,...TIMSaga]);
}
